import { wait } from './wait';

type SynchronousCallback<TReturnValue> = () => TReturnValue;
type AsynchronousCallback<TReturnValue> = () => Promise<TReturnValue>;

export const deferUntil = async <TReturnValue>(
    canStopDeferring: () => boolean,
    callback: SynchronousCallback<TReturnValue> | AsynchronousCallback<TReturnValue>,
    pollTimeInMs = 1000
): Promise<TReturnValue> => {
    if (canStopDeferring()) {
        return callback();
    }
    await wait(pollTimeInMs);
    return await deferUntil(canStopDeferring, callback, pollTimeInMs);
};
